import { Button } from 'shared/ui/Button'
import { Typography } from 'shared/ui/Typography/Typography'
import { LINK_RINGLESS_VOICEMAIL_BEST_PRACTICES } from 'shared/constants/links'
import styles from './styles.module.scss'

export const RinglessDeliveryInfo = () => (
  <div className={styles.wrap}>
    <Typography
      ariaLabel={'ringless-delivery-info'}
      variant={'body-md-regular'}
      color={'var(--content-primary-secondary)'}
    >
      Ringless voicemails typically reach 60–85% of contacts
    </Typography>
    <Button
      tag={'a'}
      href={LINK_RINGLESS_VOICEMAIL_BEST_PRACTICES}
      target={'_blank'}
      rel={'noreferrer'}
      typeBtn={'link'}
      text={'Learn why delivery varies'}
      className={styles.learnMoreBtn}
    />
  </div>
)
